/**
 * Deduplicate sentences in target paragraph that occur in source of truth
 * paragraph. Both strings are assumed to be paragraphs. A paragraph is a single
 * sentence or many sentences separated by periods or other punctuation. A
 * sentence is a string of words that ends in some kind of punctuation.
 *
 * @param dedupeTargetParagraph - the paragraph to deduplicate sentences from. If
 * falsey, an empty string is returned.
 * @param sourceOfTruthParagraph - the source of truth paragraph. If falsey, the
 * dedupeTargetParagraph is returned.
 * @returns The deduplicated paragraph or sentence
 */
export function dedupeParagraphSentences(
  dedupeTargetParagraph: string | undefined,
  sourceOfTruthParagraph: string | undefined
): string {
  if (!sourceOfTruthParagraph) return dedupeTargetParagraph ?? "";
  if (!dedupeTargetParagraph) return "";

  // assume sentences are already well punctuated with periods
  const sourceOfTruthSentences = sourceOfTruthParagraph.split(".");

  return dedupeTargetParagraph
    .split(".")
    .filter(
      (sentence) => !sourceOfTruthSentences.some((s) => s.includes(sentence))
    )
    .join(".")
    .replace(/([.!?:;])?$/, "$1")
    .replace(/([^.!?:;])$/, "$1.")
    .trim();
}
